<template>
  <nav class="aui-navgroup aui-navgroup-vertical">
    <div class="aui-navgroup-inner">
      <slot></slot>
    </div>
  </nav>
</template>

<script>
  export default {}
</script>
